"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TextPreview = exports.ImageWrapper = exports.Badge = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = exports.Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n"])));
var TextPreview = exports.TextPreview = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: var(--color-neutral-120);\n  font-size: var(--font-size-xxs);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", "\n"])), function (_ref) {
  var seen = _ref.seen;
  return !seen && "\n      color: var(--color-neutral-130);\n      font-weight: var(--font-weight-bold);\n  ";
});
var Badge = exports.Badge = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: var(--color-feedback-info-100);\n  border-radius: var(--border-radius-xs);\n  color: var(--color-feedback-info-80);\n  font-size: var(--font-size-xxxs);\n  margin-left: var(--spacing-0-5);\n  height: 0;\n  width: 0;\n  padding: 4px;\n"])));
var ImageWrapper = exports.ImageWrapper = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n"])));